var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 74,
    viewBox: "0 0 300 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000128491 59.3988L39.898 1.18872H74.7831V40.166H82.9673V62.6725H74.7831V72.8005H38.9773V62.6725H0V59.3989L0.000128491 59.3988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77 7.95217C159.586 2.42003 168.613 -0.345825 179.854 -0.345825C192.471 -0.345825 202.275 3.03015 209.266 9.78212C216.256 16.5341 219.752 25.5708 219.752 36.8922C219.752 48.1455 216.222 57.1993 209.163 64.0535C202.104 70.9078 192.301 74.3349 179.751 74.3349C168.344 74.3349 159.25 71.5754 152.471 66.0571C145.631 71.5756 136.581 74.3349 125.321 74.3349C112.704 74.3349 102.917 70.9589 95.9602 64.2069C89.0037 57.455 85.5254 48.4183 85.5254 37.0968C85.5254 25.7754 89.0719 16.7046 96.1649 9.88444C103.19 3.06427 112.943 -0.345812 125.423 -0.345812C136.845 -0.345812 145.961 2.42043 152.77 7.95218L152.77 7.95217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.083 48.8106C134.878 47.187 137.173 46.3752 139.967 46.3752C142.761 46.3752 145.056 47.187 146.852 48.8106C148.647 50.4341 149.544 52.4714 149.544 54.9223C149.544 57.3733 148.647 59.4105 146.852 61.034C145.056 62.6576 142.761 63.4694 139.967 63.4694C137.173 63.4694 134.874 62.6576 133.071 61.034C131.268 59.4105 130.366 57.3733 130.366 54.9223C130.366 52.4714 131.272 50.4341 133.083 48.8106Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.513 48.8106C189.308 47.187 191.603 46.3752 194.398 46.3752C197.192 46.3752 199.487 47.187 201.282 48.8106C203.077 50.4341 203.975 52.4714 203.975 54.9223C203.975 57.3733 203.077 59.4105 201.282 61.034C199.487 62.6576 197.192 63.4694 194.398 63.4694C191.603 63.4694 189.305 62.6576 187.502 61.034C185.698 59.4105 184.797 57.3733 184.797 54.9223C184.797 52.4714 185.702 50.4341 187.513 48.8106Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.021 59.3988L256.919 1.18872H291.804V40.166H299.988V62.6725H291.804V72.8005H255.998V62.6725H217.021V59.3989L217.021 59.3988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 74,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.fb619a4ee396154a3df8a67ef84dcf23.svg";
export { ForwardRef as ReactComponent };